@if (user) {
  <aside class="fixed left-0 top-0 h-screen w-64 bg-base-100 border-r border-base-300 flex flex-col z-40">
    <!-- Logo Section -->
    <div class="p-6 border-b border-base-300">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 bg-primary text-primary-content flex items-center justify-center font-bold rounded-lg text-lg">
          M
        </div>
        <div>
          <h1 class="text-lg font-semibold text-base-content">Mangala Motors</h1>
          <p class="text-xs text-base-content/60">Admin Portal</p>
        </div>
      </div>
    </div>

    <!-- Navigation Links -->
    <nav class="flex-1 p-4 space-y-1">
      <a
        routerLink="/"
        routerLinkActive="bg-primary text-primary-content"
        [routerLinkActiveOptions]="{ exact: true }"
        class="flex items-center gap-3 px-4 py-3 rounded-lg text-base-content hover:bg-base-200 transition-colors font-medium"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
        Orders
      </a>

      <a
        routerLink="/users"
        routerLinkActive="bg-primary text-primary-content"
        class="flex items-center gap-3 px-4 py-3 rounded-lg text-base-content hover:bg-base-200 transition-colors font-medium"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
        </svg>
        Users
      </a>

      <a
        routerLink="/customers"
        routerLinkActive="bg-primary text-primary-content"
        class="flex items-center gap-3 px-4 py-3 rounded-lg text-base-content hover:bg-base-200 transition-colors font-medium"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
        Customers
      </a>

      <a
        routerLink="/promotions"
        routerLinkActive="bg-primary text-primary-content"
        class="flex items-center gap-3 px-4 py-3 rounded-lg text-base-content hover:bg-base-200 transition-colors font-medium"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
        </svg>
        Promotions
      </a>

      <a
        routerLink="/database"
        routerLinkActive="bg-primary text-primary-content"
        class="flex items-center gap-3 px-4 py-3 rounded-lg text-base-content hover:bg-base-200 transition-colors font-medium"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" />
        </svg>
        Database
      </a>

      <a
        routerLink="/documents"
        routerLinkActive="bg-primary text-primary-content"
        class="flex items-center gap-3 px-4 py-3 rounded-lg text-base-content hover:bg-base-200 transition-colors font-medium"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        Documents
      </a>

      <a
        routerLink="/payments"
        routerLinkActive="bg-primary text-primary-content"
        class="flex items-center gap-3 px-4 py-3 rounded-lg text-base-content hover:bg-base-200 transition-colors font-medium"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z" />
        </svg>
        Receipts
      </a>
    </nav>

    <!-- Notifications -->
    <div class="px-4 pb-2">
      <app-notification-bell />
    </div>

    <!-- User Profile Section -->
    <div class="p-4 border-t border-base-300">
      <div class="relative">
        <button
          (click)="toggleDropdown()"
          class="w-full flex items-center gap-3 p-3 rounded-lg hover:bg-base-200 transition-colors"
        >
          <div class="w-10 h-10 rounded-full overflow-hidden bg-base-300">
            <img ngSrc="assets/person.png" alt="Profile" width="40" height="40" class="w-full h-full object-cover" />
          </div>
          <div class="flex-1 text-left">
            <p class="text-sm font-medium text-base-content">{{ username }}</p>
            <p class="text-xs text-base-content/60">Administrator</p>
          </div>
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-base-content/60" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        @if (isPfpDropdownVisible) {
          <div
            #dropdown
            class="absolute bottom-full left-0 right-0 mb-2 bg-base-100 border border-base-300 rounded-lg shadow-lg"
          >
            <button
              (click)="logout(); closeDropdown()"
              class="w-full flex items-center gap-3 px-4 py-3 text-sm text-error hover:bg-base-200 rounded-lg transition-colors"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
              Logout
            </button>
          </div>
        }
      </div>
    </div>
  </aside>
}
